// validator.js -- Simple form data validation

const Validator = function() { 
   
    // Result
    const result = {
        validationRan: 0,
        passed: 1,
        errorMsgs: []
    };

    const resultDefaults = {
        validationRan: 0,
        passed: 1,
        errorMsgs: []
    }

    const addError = (errMsg) => {
        result.errorMsgs.push(errMsg);
        setPassedFlagToFalse();
    };

    const setPassedFlagToFalse = () => result.passed = 0;

    const valDefined = (v) => {
        if (v === undefined) return false;
        if (v === null) return false;
        return true;
    }

    // ruleObj: "rule parameters" like the error message, min length value, etc.
    const rulesApi = {

        // ruleObj: { required: 'The error message if value not valid' }
        required: function(val,ruleObj) { 
            val = trim(val);
            if (val === '' || val === undefined || val === null) {
                const errMsg = ruleObj.required;
                addError(errMsg);
                //return false;
            }
            //return true;
            // return this;
        },

        // ruleObj: { min: [4,'The value must be at least 4 characters.'] }
        min: function(val,ruleObj) {
            val = trim(val);
            // Only run check if there's actually a value of non-zero length to check - cleaner
            // overall error message this way, e.g. if value is 'required', NOT doing this
            // gives BOTH (want one message at a time on given field): 'xxx is required. xxx must have minimum length'
            if (val.length === 0) {
                return;
            }
            if (val.length < ruleObj.min[0]) {
                const errMsge = ruleObj.min[1];
                addError(errMsge);
                // addError(`Value must have at least ${minLength} characters.`);
            }
            // return this;
        },

        // ruleObj: { max: [4,'The value must be at most 4 characters.'] }
        max: function(val,ruleObj) {
            val = trim(val);
            // Only run check if there's actually a value of non-zero length to check - cleaner
            // overall error message this way, e.g. if value is 'required', NOT doing this
            // gives BOTH (want one message at a time on given field): 'xxx is required. xxx must have minimum length'
            if (val.length === 0) {
                return;
            }
            if (val.length > ruleObj.max[0]) {
                const errMsge = ruleObj.max[1];
                addError(errMsge);
            }
            // return this;
        },

        // ruleObj: { cannotBe: { '-': 'A country must be selected.'

        //                      }
        //          }
        cannotBe: function(val,ruleObj) {
            val = trim(val);
            if (val.length === 0) {
                return;
            }

            let cannotBe = ruleObj.cannotBe[0];
            if(!Array.isArray(cannotBe)) {
                cannotBe = cannotBe.split('');
            }

            if (cannotBe.includes(val)) {
                const errMsge = ruleObj.cannotBe[1];
                addError(errMsge);
            }
        },

        email: function(val,ruleObj) {
            val = trim(val);
            if (val.length === 0) {
                return;
            }
            // From: https://developer.mozilla.org/en-US/docs/Learn/HTML/Forms/Form_validation
            // As per the HTML5 Specification:
            const emailRegExp = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

            const isValidEmail = emailRegExp.test(val);
            if (!isValidEmail) {
                const errMsg = ruleObj.email;
                addError(errMsg);
            }
        },

        // Form checkbox
        checkboxRequired: function(val,ruleObj,fieldId) {
            const checkBoxEl = document.querySelector(`#${fieldId}`);
            if (!checkBoxEl.checked) {
                const errMsg = ruleObj.checkboxRequired;
                addError(errMsg);
            }
        },

        

        // Match value in another field
        // formData: The object of fieldNames/values being validated - to give access to OTHER field being matched against.
        // ruleObj: { matchField: ['nameOfMatchField','The value must match labelOfMatchField'] }
        matchField: function(val,ruleObj,fieldId,formData) {
            val = trim(val);
            if (val === '' || val === undefined || val === null) {
                return;
            }
            const matchFieldName = ruleObj.matchField[0];
            if (matchFieldName === undefined) {
                return;
            }
            const matchFieldVal = trim(formData[matchFieldName]);
            if (matchFieldVal === '' || matchFieldVal === undefined || matchFieldVal === null) {
                return;
            }
            if (val !== matchFieldVal) {
                const errMsge = ruleObj.matchField[1];
                addError(errMsge);
            }

        }
        


    }

    

    const trim = (val) => {
        if (valDefined(val)) {
            val = val.toString().trim();
        }
        return val;
    }
    // Start the passed in value off by getting trimmed, no matter what.
    // Once done, now ready for validation tests (i.e. the various validation methods).
    // if (valDefined(val)) {
    //     val = val.toString().trim();
    // }
    

    // Function arguments (from above - here for reference) --> 
    //          const Validator = function(validateThis,rules) { ...

    // Do the validation check -- and therefore list the error messages for each field -- in the order
    // given in 'validateThis' (i.e. this could be the app's or form's "state" object, for example)
    // ------------
    // const validateViaValues = function(validateThis,rules) {
    //     for (let fieldNameToValidate in validateThis) {
    //         // validationRule is the NAME of the rule, e.g. required, min, email, ... (etc)
    //         for (let validationRule in rules[fieldNameToValidate]) {
    //             const fieldValue = validateThis[fieldNameToValidate];
    //             //console.log(rules[fieldNameToValidate]);
    //             const ruleObj = rules[fieldNameToValidate];

    //             // validationRule matches with function name... run that function to do the validation check
    //             rulesApi[validationRule](fieldValue,ruleObj);

    //         }
    //     }
    // }

    // Do the validation check in order of the properties (keys) of the 'rules' object
    // ------------
    const validateViaRules = function(validateThis,rules) {
        for (let fieldNameToValidate in rules) {
            // validationRule is the NAME of the rule, e.g. required, min, email, ... (etc)
            for (let validationRule in rules[fieldNameToValidate]) {
                let fieldId = '';   
                
                const fieldValue = validateThis[fieldNameToValidate];
                const ruleObj = rules[fieldNameToValidate];
                if (validationRule === 'checkboxRequired') {
                    fieldId = fieldNameToValidate;
                }
                
                // validationRule matches with function name... run that function to do the validation check.
                // Do the validation only if the fieldValue is defined, e.g. the property on the validateThis
                // object (argument) exists.
                if (fieldValue !== undefined) {
                    rulesApi[validationRule](fieldValue,ruleObj,fieldId,validateThis);
                }

            }
        }
    }

    const api = {

        // validateThis obj, rules obj
        validate: function(validateThis,rules) {
            // Start with fresh result object (so there's no "memory" of previous run of validate)
            this.resetResults();
            result.validationRan = 1;
            validateViaRules(validateThis,rules);
        },
        getResult: function() {
            return result
        },
        validationPassed: function() {
            if (!this.getResult().validationRan) {
                addError('Validator method not called!');
                return false;
            }
            return this.getResult().passed;
        },
        getErrors: function() { 
            const errors = this.getResult().errorMsgs;
            return errors;
        },
        resetResults: function() {
            for (let p in resultDefaults) {
                result[p] = resultDefaults[p]
            }
            // Handle the array of errorMsgs separately since
            // doing this: result[errorMsgs] = []  ... will NOT show the value as an empty array
            // since there are references to this object/property elsewhere.
            const emptyArr = [];
            result.errorMsgs = emptyArr;
        }
    }
    

    Validator.prototype = Object.assign(Validator.prototype,rulesApi,api);
    const validator = Object.create(Validator.prototype);


    // return api.getResult();

    return validator;
}


// let name = '     ';
// const v = Validator(name);
// console.table(v.required().min(4).max(15).getResult());
// v.required().cannotBe('-').min(4).max(15);
// console.log(v.getResult());
// console.log('PROCESSED VALUE',v.getVal());

export default Validator;

